import withEntity from '@/entity/components/with-entity';

import Header from './header';

export default withEntity(Header);
